import { SEND_LIMITS } from './safety.js';
export const EVENT_OPPORTUNITY_COOLDOWN_BUSINESS_DAYS = 4;
export function normaliseOfficeLocation(value) {
    return String(value || '')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/\b(office|hq|headquarters)\b/g, ' ')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
}
/**
 * Missing location data is treated conservatively as the same office. When both
 * contacts have explicit city/office labels, different labels break the cooldown.
 */
export function sameCooldownOffice(a, b) {
    const left = normaliseOfficeLocation(a);
    const right = normaliseOfficeLocation(b);
    if (left && right)
        return left === right;
    return true;
}
export function isUpcomingEventOpportunity(opportunity, now = new Date()) {
    if (!opportunity || opportunity.type !== 'future-event')
        return false;
    if (opportunity.status === 'closed' || opportunity.status === 'too-late')
        return false;
    const end = Date.parse(opportunity.eventEnd || opportunity.eventStart || '');
    if (Number.isFinite(end) && end < now.getTime())
        return false;
    return true;
}
export function addBusinessDays(anchor, days) {
    const date = new Date(anchor);
    if (Number.isNaN(date.getTime()))
        return new Date(Number.NaN);
    let remaining = Math.max(0, Math.trunc(days));
    while (remaining > 0) {
        date.setUTCDate(date.getUTCDate() + 1);
        const weekday = date.getUTCDay();
        if (weekday !== 0 && weekday !== 6)
            remaining--;
    }
    return date;
}
export function outreachCooldownUntil(anchor, opportunity) {
    const start = new Date(anchor);
    if (Number.isNaN(start.getTime()))
        return new Date(Number.NaN);
    if (isUpcomingEventOpportunity(opportunity, start))
        return addBusinessDays(start, EVENT_OPPORTUNITY_COOLDOWN_BUSINESS_DAYS);
    return new Date(start.getTime() + SEND_LIMITS.teamCooldownDays * 24 * 3600_000);
}
export function outreachCooldownLabel(opportunity) {
    return isUpcomingEventOpportunity(opportunity)
        ? `${EVENT_OPPORTUNITY_COOLDOWN_BUSINESS_DAYS} business days`
        : `${SEND_LIMITS.teamCooldownDays} days`;
}
